import { If, withLazyLoad } from "../../common/ui"
import DashboardSkeleton from "../../common/ui/skeletons/dashboard/index"
import Charts from "../../common/ui/dashboard/charts"
import Stats from "../../common/ui/dashboard/stats"
import DashboardActivityTable from "../../common/ui/dashboard/activity-table"
import {
  useFetchIntegrationsQuery,
  useFetchOrgDetailsQuery,
  useFetchLoanOfficersQuery
} from "../../redux/queries"
import { selectUserDetails } from "../../redux/slices/auth"
import { useAppSelector } from "../../common/hooks"
import { getOrgBrandsIDs } from "../../common/utils"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

const LazyLoadedDashboardActivityTable = withLazyLoad(DashboardActivityTable)
const LazyLoadedCharts = withLazyLoad(
  Charts,
  "flex flex-col lg:flex-row gap-6 w-full"
)

const DashboardPage = () => {
  const user = useAppSelector(selectUserDetails)
  const { data: orgDetails, isFetching: isFetchingOrgDetails } =
    useFetchOrgDetailsQuery(
      { id: user?.org?.id ?? "" },
      { skip: !user?.org?.id }
    )

  const { data: membersData, isFetching: isFetchingMembers } =
    useFetchLoanOfficersQuery(
      { org_id: orgDetails?.id ?? "" },
      {
        skip: !orgDetails?.id
      }
    )

  const brandsIDs = getOrgBrandsIDs(orgDetails)
  const { data: integrations, isFetching: isFetchingIntegrations } =
    useFetchIntegrationsQuery({
      org_id: orgDetails?.id,
      brand_id: brandsIDs,
      limit: 9999
    })

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE.dashboard}>
      <div>
        <If
          condition={
            isFetchingOrgDetails || isFetchingMembers || isFetchingIntegrations
          }
          then={<DashboardSkeleton />}
          else={
            <div className="h-full bg-primary-100">
              <div className="py-4 px-6 bg-white flex items-center justify-between">
                <div className="flex items-center">
                  <h2 className="font-roboto-slab">Dashboard</h2>
                  <div className="px-2 text-base text-gray-400 hidden md:block">
                    &#8226;&nbsp;{orgDetails?.name}
                  </div>
                </div>
              </div>

              {/* Overall Stats */}
              <div className="p-6">
                <Stats
                  brands={orgDetails?.brands?.length ?? 0}
                  los={membersData?.los?.length ?? 0}
                  integrations={integrations?.length ?? 0}
                  orgId={orgDetails?.id ?? ""}
                />
              </div>

              {/* Activity List */}
              <div className="p-6 pt-0">
                <LazyLoadedDashboardActivityTable />
              </div>

              {/* Charts */}
              <div className="p-6 pt-0">
                <LazyLoadedCharts orgId={orgDetails?.id} />
              </div>
            </div>
          }
        />
      </div>
    </RequireRole>
  )
}

export default DashboardPage
